import { fetchPartners } from "@/api/partners";
import { API_URL } from "@/api/apiRequest";

export const loadPartners = async ({ state }) => {
  const response = await fetchPartners();
  const partners = response.map(item => {
    console.log(`${API_URL}/${item.img}`);
    return { ...item, img: `${API_URL}/${item.img}` };
  });
  state.partners = partners;
};
